<template>
  <div id="sellorder">
     <div>
      <!-- <el-select v-model="para.status" placeholder="请选择" @change="handleChangeOrderStatus" clearable>
        <el-option
          v-for="n in statuslist"
          :key="n.key"
          :label="n.label"
          :value="n.value">
        </el-option>
      </el-select> -->
      <!-- <el-select v-model="queryBycompanyStatus" placeholder="请选择" @change="handleChangeCompanyStatus">
        <el-option
          v-for="n in companyStatus"
          :key="n.key"
          :label="n.label"
          :value="n.value">
        </el-option>
      </el-select> -->
      <el-input v-model="para.searchKey" placeholder="请输入合同号/型号" @change="handleChangeCompanySearchkey"></el-input>
    </div>
    <div class="comond_btn">
      <el-button  @click="handleEdit(0, null)" >创建采购订单</el-button>
    </div>
    <template>
      <el-table
        :data="list"
        style="width: 100%">

        <el-table-column
          prop="contractNum"
          label="采购合同号"
          width="">
        </el-table-column>

        <el-table-column
          prop="goodsName"
          label="商品名称">
        </el-table-column>
        
        <el-table-column
          prop="model"
          label="型号">
        </el-table-column>

        <el-table-column
          prop="netWeight"
          label="采购数量净重(公斤)">
        </el-table-column>

        <el-table-column
          prop="purchaseTwo"
          label="采购单价/公斤">
        </el-table-column>

        <el-table-column
          prop="currency"
          label="币种">
        </el-table-column>

        <el-table-column
          label="要求到港时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.startDate) }}</div>
           </template>
        </el-table-column>

         <el-table-column
          prop="companyName"
          label="供货商">
        </el-table-column>

        <el-table-column
          label="下单日期">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.orderDate) }}</div>
           </template>
        </el-table-column>

        <el-table-column
          label="状态">
          <template slot-scope="scope">
             <div>{{ resetstatus(scope.row.purchaseStatus) }}</div>
           </template>
        </el-table-column>

        <el-table-column
          width="240"
          label="操作选项">
           <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              v-if="scope.row.purchaseStatus === 1"
              @click="handleEdit(1, scope.row)">编辑</el-button>
              
            <!-- <el-button  
              size="mini"
              @click="handleEdit(1, scope.row)">编辑</el-button> -->
            <el-button
              size="mini"
              type="primary"
              v-if="scope.row.purchaseStatus === 4"
              @click="handleEdit('编辑', scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="info"
              v-if="scope.row.purchaseStatus === 3"
              @click="handleEdit('付汇', scope.row)">付汇</el-button>
            <el-button
              size="mini"
              type="danger"
              v-if="scope.row.purchaseStatus === 1"
              @click="handleDelete(3, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
       <div style="text-align:center;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="handelCurrentChange"
          :current-page="para.pageIndex"
          :total="total">
        </el-pagination>
      </div>
    </template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="50%"
        center>

        <el-form :model="form" :rules="rules">

          <div v-if="currentStatus === 0 || currentStatus === 1">
            <el-form-item label="采购合同号" class="dbgroup" :label-width="formLabelWidth" prop="contractNum">
              <el-input v-model="form.contractNum">
                <el-button slot="append" class="btnin" @click="autogeneration">自动生成</el-button>
              </el-input>
            </el-form-item>
          
            <el-form-item label="商品名称" :label-width="formLabelWidth">
              <el-select v-model="form.goodsId" placeholder="请选择" @change="handelchangegoods">
                <el-option
                  v-for="item in goodsList"
                  :key="item.key"
                  :label="item.cnName?item.cnName:item.enName"
                  :value="item.id">
                  <span style="float: left">{{ item.cnName + ' /' }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{item.enName + ' : ' + item.model }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="型号" :label-width="formLabelWidth" prop="model">
              <el-input v-model="form.model" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="规格" class="dbgroup" :label-width="formLabelWidth">
              <el-input v-model="form.packWeight" :disabled="true">
                <el-button slot="append">{{ form.goodsSpec }}</el-button>
              </el-input>
            </el-form-item>

            <el-form-item label="供货商" :label-width="formLabelWidth" prop="supplierId">
              <el-select v-model="form.supplierId" placeholder="请选择" @visible-change="(value) => { return handelchangecompany(value, 2)}">
                <el-option
                  v-for="item in companylist"
                  :key="item.key"
                  :label="item.chineseName?item.chineseName:item.englishName"
                  :value="item.id">
                  <span style="float: left">{{ item.chineseName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="采购数量(净重)" class="dbgroup" :label-width="formLabelWidth" prop="salesQuantity">
              <el-input v-model="form.netWeight">
                <el-button slot="append">公斤</el-button>
              </el-input>
            </el-form-item>

            <!-- <el-form-item label="采购单价" class="dbgroup" :label-width="formLabelWidth" prop="salesQuantity">
              <el-input v-model="form.purchaseOne">
                <el-select slot="append" v-model="form.unitOne" placeholder="请选择" @visible-change="handelchangecurrency">
                <el-option
                  v-for="item in currencyList"
                  :key="item.key"
                  :label="item.currency"
                  :value="item.code">
                </el-option>
              </el-select>
              </el-input>
            </el-form-item> -->

            <el-form-item label="采购单价" class="dbgroup" :label-width="formLabelWidth" prop="salesQuantity">
              <el-input v-model="form.purchaseTwo">
                <el-select slot="append" v-model="form.unitTwo" placeholder="请选择" @visible-change="handelchangecurrency">
                  <el-option
                    v-for="item in currencyList"
                    :key="item.key"
                    :label="item.currency"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-input>
            </el-form-item>

            <el-form-item label="下单时间" :label-width="formLabelWidth">
              <el-date-picker
                v-model="form.orderDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>

            <p class="choosetime">
              <el-form-item label="要求到货时间" :label-width="formLabelWidth">
                <el-date-picker
                  v-model="form.startDate"
                  type="date"
                  placeholder="最早供货时间">
                </el-date-picker>
                <div style="margin: 0 10px"> - </div>
                <el-date-picker
                  v-model="form.endDate"
                  type="date"
                  placeholder="最晚供货时间">
                </el-date-picker>
              </el-form-item>
            </p>

            <p class="choosetime">
              <el-form-item label="预计船期" :label-width="formLabelWidth">
                <el-date-picker
                  v-model="form.atd"
                  type="date"
                  placeholder="预计开船期">
                </el-date-picker>
                <div style="margin: 0 10px"> - </div>
                <el-date-picker
                  v-model="form.ata"
                  type="date"
                  placeholder="预计到港期">
                </el-date-picker>
              </el-form-item>
            </p>
          </div>

          <!-- 付汇 -->
          <div v-if="currentStatus === '编辑' || currentStatus === '付汇'">

            <el-form-item label="付汇金额" class="dbgroup" :label-width="formLabelWidth">
              <el-input v-model="form.paymentMoney">
                <el-select slot="append" v-model="form.currencyid" placeholder="请选择" @visible-change="handelchangecurrency">
                  <el-option
                    v-for="item in currencyList"
                    :key="item.key"
                    :label="item.currency"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-input>
            </el-form-item>

            <el-form-item label="付汇日期" class="dbgroup" :label-width="formLabelWidth">
              <el-date-picker
                v-model="form.payTime"
                type="date"
                placeholder="付汇日期"
                >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="付汇汇率" class="dbgroup" :label-width="formLabelWidth">
              <el-input v-model="form.exchangeRate"></el-input>
            </el-form-item>

          </div>
        
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button  @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handlesuccess(sts)">确 定</el-button>
        </span>

      </el-dialog>
    </div>
  </div>
</template>
<script>
import { 
  goodsfindAll, purchasegetById, goodsqueryById, 
  findAll, crmcurrency, stockgoods, 
  purchasefindAll, purchaseadd, purchaseupdateById,
  purchasepayment, purchasequerypayment
} from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
export default {
  data () {
    return {
      list: [],
      centerDialogVisible: false,
      form: { //  新增初始化form
        model: '',
        packWeight: '',
        goodsSpec: ''
      },
      formLabelWidth: '120px',
      sts: 0, //  0 添加, 1 编辑 2 编辑权限
      title: '', //  添加窗口标题
      currentpageIndex: 1,
      currentpageSize: 10,
      total: 0,
      isshow: false,
      currentStatus: '',
      statuslist: [
        {
          label: '所有',
          value: ''
        },
        {
          label: '有效',
          value: 1
        },
        {
          label: '无效',
          value: 2
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'contractNum',
      },
      batchNumberIds: [],
      defaultchecked: [],
      goodsList: [],
      companylist: [],
      currencyList: [],
      rules: {
        name: [
          { type: 'string', required: true, message: '请输入角色名', trigger: 'blur' },
        ],
        description: [
          { type: 'string', required: true, message: '请输入角色描述', trigger: 'blur' },
        ]
      },
      para: {
        // status: 1,
        contractNum: "",
        purchaseStatus: "",
        supplierId: "",
        goodsId: "",
        searchKey: '', //  合同号
        pageIndex: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.getorderqueryList(this.para)
  },
  methods: {
    handelCurrentChange (i) { // 分页
      this.para.pageIndex = i
      this.getorderqueryList(this.para)
    },
    handleCheckChange (data, checked, indeterminate) {
      console.log(1)
      if (checked !== false) {
        this.form.batchNumberIds.push(data.shipId)
      } else {
        this.form.batchNumberIds.splice(this.form.batchNumberIds.indexOf(data.shipId), 1)
      }
      console.log(this.form.batchNumberIds)
    },
    autogeneration () { //  自动生成合同号
      this.form.contractNum = 'ly' + Math.round(new Date().getTime())
    },
    getcrmcurrency () { //  货币类型
      let para = {}
      crmcurrency(para).then(data => {
        console.log(data)
        this.currencyList = data.data.data
      })
    },
    handelchangecurrency (val) {
      this.getcrmcurrency()
    },
    handelchangecompany (val, type) { //  采购商
      let para = {
        'status': 1,
        'typeId': type
      }
      console.log(1)
      findAll(para).then(data => {
        this.companylist = data.data.data
      })
    },
    getgoodsfindAll () { //  查询商品列表
      let para = {
        status: 1
      }
      goodsfindAll(para).then(data => {
        console.log(data)
        this.goodsList = data.data.data.rows
      })
    },
    handelchangegoods (val) { //  根据商品id填充规格
      let para = {
        id: val
      }
      goodsqueryById(para).then(data => {
        console.log(data)
        if (data.data.data.model) {
          this.form.model = data.data.data.model
        }
        if (data.data.data.packWeight) {
          this.form.packWeight = data.data.data.packWeight
        }
        if (data.data.data.goodsSpec) {
          this.form.goodsSpec = data.data.data.goodsSpec
        }
      })
      this.getstockgoods(val)
    },
    getstockgoods (val) { //  查询余量
      let para = new URLSearchParams()
      para.append('goodsId', val)
      stockgoods(para).then(data => {
        console.log(data)
        this.batchNumberIds = this.changeArray(data)
      })
    },
    changeArray (data) {
      console.log(data)
      if (data.data) {
        let arr = []
        for (let i = 0; i<data.data.length; i++) {
          let a  = {}
          a.contractNum = data.data[i].locationName
          a.shipId = data.data[i].locationId
          a.children = data.data[i].contractGoodsVos
          arr.push(a)
          let e = []
          if (arr[i].batchNumberGoods) {
            arr[i].batchNumberGoods.forEach(element => {
              let b = {}
              b.contractNum = element.lotNum + element.allowance //  库存
              b.shipId = element.id
              e.push(b)
            })
            arr[i].batchNumberGoods = e
          }
        }
        return arr
      } else {}
    },
    handleEdit (ind, row) { //  编辑或者新增
      console.log(ind, row)
      this.getgoodsfindAll()
      this.getcrmcurrency()
      this.centerDialogVisible = true
      this.sts = ind
      this.currentStatus = ind
      switch (ind) {
        case 1:
          this.handelchangegoods(row.goodsId)
          this.handelchangecompany("", 2)
          this.title = '编辑采购订单'
          this.getpurchasegetById(row.id)
          break
        case 0:
          this.title = '创建采购订单'
          this.form = {
            model: '',
            packWeight: '',
            contractNum: '',
            unitOne: 1,
            unitTwo: 3
          }
          break
        case '编辑':
          this.getpurchasequerypayment(row.id)
          break
        case '付汇':
          this.form = row
          break
      }
    },
    postpurchasepayment () { //  付汇
      this.form.payTime = this.formatime(this.form.payTime)
      let para = new URLSearchParams(this.form)
      purchasepayment(para).then(res => {
        console.log(res)
        let { data, code, msg } = res
        if (code === 10000) {
          this.$message.success(msg)
          this.getorderqueryList(this.para)
          this.centerDialogVisible = false
        } else {
          this.$message.error(msg)
        }
      })
    },
    getpurchasequerypayment (id) { //  查询付汇
      let para = {
        id: id
      }
      purchasequerypayment(para).then(res => {
        console.log(res)
        let { data, code, msg } = res.data
        this.form = data
      })
    },
    getpurchasegetById (id) {
      let para = new URLSearchParams()
      para.append('id', id)
      purchasegetById(para).then(data => {
        console.log(data)
        this.form = data.data.data
      })
    },
    handlesuccess (sts) { //  提交修改信息
      this.form.startDate = this.formatime(this.form.startDate)
      this.form.endDate = this.formatime(this.form.endDate)
      this.form.orderDate = this.formatime(this.form.orderDate)
      this.form.ata = this.formatime(this.form.ata)
      this.form.atd = this.formatime(this.form.atd)
      let para
      switch (sts) {
        case 0:
          para = new URLSearchParams(this.form)
          purchaseadd(para).then(data => {
            if (data.code === 10000) {
              this.$message({
                message: data.msg,
                type: 'success'
              })
              this.getorderqueryList(this.para)
              this.centerDialogVisible = false
            } else {
              this.$message({
                message: data.msg,
                type: 'error'
              })
            }
          })
          break
        case 1:
          this.form.createDate = this.formatime(this.form.createDate)
          this.form.updateDate = this.formatime(this.form.updateDate)
          para = new URLSearchParams(this.form)
          purchaseupdateById(para).then(data => {
            if (data.code === 10000) {
              this.$message({
                message: data.msg,
                type: 'success'
              })
              this.getorderqueryList(this.para)
              this.centerDialogVisible = false
            } else {
              this.$message({
                message: data.msg,
                type: 'error'
              })
            }
          })
          break
        case '编辑':
          this.postpurchasepayment()
          break
        case '付汇':
          this.postpurchasepayment()
          break
      }
    },
    handleDelete (ind, row) { //  删除
      let para = new URLSearchParams()
      para.append('id', row.id)
      para.append('status', 2)
      purchaseupdateById(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getorderqueryList(this.para)
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    getorderqueryList (obj) { //  查询采购订单
      let para = obj
      purchasefindAll(para).then(data => {
        console.log(data)
        if (data.data.data.rows) {
          this.list = data.data.data.rows
        } else {
          this.list = []
        }
        this.total = data.data.data.total
      })
    },
    handleChangeOrderStatus (val) {
      this.getorderqueryList(this.para)
    },
    handleChangeCompanySearchkey (val) {
      this.getorderqueryList(this.para)
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
    resetstatus (s) {
      switch (s) {
        case 1:
          return "预购"
          break
        case 2:
          return "已发货"
          break
        case 3:
          return "已入库"
          break
        case 4:
          return "已付汇"
          break
      }
    }
  },
}
</script>
<style lang="stylus">
#sellorder 
  .el-input__inner
    width 180px
  .dbgroup
    .el-input-group
      display flex
    .el-input-group__append
      width 50px
      line-height: 2em;
      padding-top: 5px;
    .el-input__suffix
      right 95px
.comond_btn
  display flex
  justify-content flex-end
  margin-bottom 30px
  button
    background-color #0a3d5f
    color #fff
.choosetime
  .el-form-item__content
    display flex
</style>
